var map = {
	"./package_1.png": 6683,
	"./package_2.png": 8420,
	"./package_3.png": 6207,
	"./package_4.png": 9630,
	"./package_5.png": 3880,
	"./package_6.png": 1442,
	"./package_small_1.png": 3067,
	"./package_small_2.png": 1539,
	"./package_small_3.png": 1531,
	"./package_small_4.png": 6229,
	"./package_small_5.png": 5621,
	"./package_small_6.png": 5685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3758;